"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.set = exports.removeFilterOptions = exports.omit = exports.isFilterSingleOption = exports.isFilterOptionSelected = exports.isFilterInUse = exports.addFilterOptions = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof3(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if ((0, _typeof2["default"])(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if ((0, _typeof2["default"])(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var addFilterOptions = function addFilterOptions(activeFilters, name, options) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _ = activeFilters[name],
      rest = (0, _objectWithoutProperties2["default"])(activeFilters, [name].map(_toPropertyKey));
  return Object.assign({}, rest, (0, _defineProperty2["default"])({}, name, options));
};

exports.addFilterOptions = addFilterOptions;

var removeFilterOptions = function removeFilterOptions(activeFilters, name, options) {
  var _activeFilters$name = activeFilters[name],
      existing = _activeFilters$name === void 0 ? [] : _activeFilters$name,
      rest = (0, _objectWithoutProperties2["default"])(activeFilters, [name].map(_toPropertyKey));
  var remaining = existing.filter(function (option) {
    return !options.includes(option);
  });
  return Object.assign({}, rest, remaining.length > 0 ? (0, _defineProperty2["default"])({}, name, remaining) : {});
};

exports.removeFilterOptions = removeFilterOptions;

var omit = function omit(obj, name) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _ = obj[name],
      rest = (0, _objectWithoutProperties2["default"])(obj, [name].map(_toPropertyKey));
  return rest;
};

exports.omit = omit;

var set = function set(obj, name, value) {
  return Object.assign({}, obj, (0, _defineProperty2["default"])({}, name, [value]));
};

exports.set = set;

var isFilterInUse = function isFilterInUse(activeFilters, filter) {
  var _activeFilters$filter;

  return ((_activeFilters$filter = activeFilters[filter]) !== null && _activeFilters$filter !== void 0 ? _activeFilters$filter : []).length > 0;
};

exports.isFilterInUse = isFilterInUse;

var isFilterOptionSelected = function isFilterOptionSelected(activeFilters, filter, filterOption) {
  var _activeFilters$filter2;

  return ((_activeFilters$filter2 = activeFilters[filter]) !== null && _activeFilters$filter2 !== void 0 ? _activeFilters$filter2 : []).includes(filterOption);
};

exports.isFilterOptionSelected = isFilterOptionSelected;

var isFilterSingleOption = function isFilterSingleOption(name, options) {
  return options.length === 1 && options[0] === name;
};

exports.isFilterSingleOption = isFilterSingleOption;
//# sourceMappingURL=filter-state.js.map